export default __webpack_public_path__ + "static/media/real-page-logo-large.e9a53165.svg";